import type {PaletteMode} from '@mui/material';
import {getHintTextColor, getStylePropertyFn} from '.';

export const getThemePalette = (mode: PaletteMode, opts?: {demo?: boolean}) => {
	const getStyleProperty = getStylePropertyFn(mode, opts);
	return {
		mode,
		background: {
			paper: getStyleProperty('surface'),
			default: getStyleProperty('background'),
		},
		primary: {
			contrastText: getStyleProperty('on-primary'),
			main: getStyleProperty('primary'),
		},
		secondary: {
			contrastText: getStyleProperty('on-secondary'),
			main: getStyleProperty('secondary'),
		},
		success: {
			main: '#4caf50',
		},
		text: {
			secondary: getHintTextColor(mode),
		},
		custom: {
			background: {
				accent: getStyleProperty('custom-background-accent'),
				backdrop: getStyleProperty('custom-backdrop'),
				light: getStyleProperty('custom-background-light'),
			},
			border:
				mode == 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.16)',
			icon: {
				onBackground: getStyleProperty('text-icon-on-background'),
			},
		},
	};
};
